document.addEventListener('DOMContentLoaded', () => {
  const moveArticleSections = () => {
    const movableSections = document.querySelectorAll('[data-article-movable][data-article-slot-id]');

    movableSections.forEach((section) => {
      const slotId = section.dataset.articleSlotId?.trim();
      if (!slotId) return;

      const slot = document.querySelector(
        `.article__content [data-article-slot="${CSS.escape(slotId)}"], .rte [data-article-slot="${CSS.escape(slotId)}"]`
      );

      if (!slot) return;

      slot.replaceWith(section);
      section.classList.add('is-article-mounted');
    });
  };

  const initArticleToc = () => {
    const articleContent = document.querySelector('.article__content');
    if (!articleContent) return;

    const headings = articleContent.querySelectorAll('h2');
    if (!headings.length) return;

    const existingToc = document.querySelector('[data-article-toc]');
    if (existingToc) existingToc.remove();

    const tocBlock = document.createElement('div');
    tocBlock.className = 'article-toc';
    tocBlock.setAttribute('data-article-toc', '');

    const labelWrap = document.createElement('div');
    labelWrap.className = 'article-toc__label-wrap';
    labelWrap.innerHTML = '<span class="article-toc__label">INDEX</span>';
    tocBlock.appendChild(labelWrap);

    const box = document.createElement('div');
    box.className = 'article-toc__box';

    const tocList = document.createElement('ol');
    tocList.className = 'article-toc__list';
    tocList.setAttribute('data-article-toc-list', '');

    headings.forEach((heading, index) => {
      const number = index + 1;
      const id = `article-toc-1-heading-${number}`;

      heading.setAttribute('id', id);

      const li = document.createElement('li');
      li.className = 'article-toc__item';

      li.innerHTML = `
          <a class="article-toc__link" href="#${id}">
            <span class="article-toc__num">${number}.</span>
            <span class="article-toc__text">${heading.textContent.trim()}</span>
          </a>
        `;

      tocList.appendChild(li);
    });

    box.appendChild(tocList);
    tocBlock.appendChild(box);

    headings[0].insertAdjacentElement('beforebegin', tocBlock);
  };

  const initSupervisor = () => {
    const holder = document.querySelector('[data-article-supervisor-holder]');
    if (!holder) return;

    const supervisor = holder.querySelector('.article-supervisor');
    if (!supervisor) return;

    const tocBlock = document.querySelector('.article__content [data-article-toc]');

    if (tocBlock) {
      tocBlock.insertAdjacentElement('afterend', supervisor);
    } else {
      const articleContent = document.querySelector('.article__content');
      const firstH2 = articleContent?.querySelector('h2');
      if (firstH2) {
        firstH2.insertAdjacentElement('beforebegin', supervisor);
      }
    }

    holder.remove();
  };

  const initSimpleTables = async () => {
  const tables = document.querySelectorAll('table.simple-table');

  const fetchSimpleTableItem = async (cell) => {
    const link = cell.querySelector('a');
    const fallbackTitle = cell.textContent.trim();

    if (!link) {
      return {
        type: 'manual',
        title: fallbackTitle,
        url: '',
        image: '',
        buttonText: ''
      };
    }

    const rawUrl = link.getAttribute('href');
    let title = fallbackTitle;
    let image = '';
    let type = 'manual';
    let buttonText = '';

    let parsedUrl;

    try {
      parsedUrl = new URL(rawUrl, window.location.origin);
    } catch (error) {
      return {
        type,
        title,
        url: rawUrl,
        image,
        buttonText
      };
    }

    const pathname = parsedUrl.pathname.replace(/\/$/, '');
    const displayUrl = parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;

    try {
      let fetchUrl = '';

      if (pathname.includes('/products/')) {
        type = 'product';
        buttonText = '購入する';
        fetchUrl = `${pathname}.js`;
      } else if (pathname.includes('/collections/')) {
        type = 'collection';
        buttonText = '一覧を見る';
        fetchUrl = `${pathname}?view=simple-table-json`;
      }

      if (fetchUrl) {
        const response = await fetch(fetchUrl);

        if (response.ok) {
          const data = await response.json();

          title = data.title || fallbackTitle;

          if (type === 'product') {
            image = data.featured_image || '';
          }

          if (type === 'collection') {
            image = data.image || '';
          }
        }
      }
    } catch (error) {
      console.warn('Simple table item fetch failed:', rawUrl, error);
    }

    return {
      type,
      title,
      url: displayUrl,
      image,
      buttonText
    };
  };

  for (const table of tables) {
    if (table.dataset.simpleTableEnhanced === 'true') continue;
    table.dataset.simpleTableEnhanced = 'true';

    const theadCells = table.querySelectorAll('thead th');
    const bodyRows = table.querySelectorAll('tbody tr');

    if (theadCells.length < 2 || bodyRows.length === 0) continue;

    const tableItems = await Promise.all(
      Array.from(theadCells).slice(1).map(fetchSimpleTableItem)
    );

    Array.from(theadCells).slice(1).forEach((cell, index) => {
      const item = tableItems[index];
      if (!item) return;

      const card = document.createElement('div');
      card.className = 'simple-table__product-card';

      if (item.image) {
        const imageWrap = document.createElement('div');
        imageWrap.className = 'simple-table__product-image-wrap';

        const imageLink = document.createElement(item.url ? 'a' : 'div');
        if (item.url) imageLink.href = item.url;

        const img = document.createElement('img');
        img.className = 'simple-table__product-image';
        img.src = item.image;
        img.alt = item.title;

        imageLink.appendChild(img);
        imageWrap.appendChild(imageLink);
        card.appendChild(imageWrap);
      }

      const title = document.createElement('p');
      title.className = 'simple-table__product-title';

      const titleLink = document.createElement(item.url ? 'a' : 'span');
      titleLink.className = 'simple-table__product-title-link';
      titleLink.textContent = item.title;
      if (item.url) titleLink.href = item.url;

      title.appendChild(titleLink);
      card.appendChild(title);

      if (item.url && item.buttonText) {
        const button = document.createElement('a');
        button.className = 'btn btn--primary btn--small';
        button.href = item.url;

        const span = document.createElement('span');
        span.className = 'btn__text flex gap-1 items-center';
        span.textContent = item.buttonText;

        button.appendChild(span);
        card.appendChild(button);
      }

      cell.innerHTML = '';
      cell.appendChild(card);
    });

    const mobileWrap = document.createElement('div');
    mobileWrap.className = 'simple-table-mobile';

    tableItems.forEach((item, itemIndex) => {
      const mobileItem = document.createElement('div');
      mobileItem.className = 'simple-table-mobile__item';

      const title = document.createElement('h4');
      title.className = 'simple-table-mobile__title';

      const titleLink = document.createElement(item.url ? 'a' : 'span');
      titleLink.className = 'simple-table-mobile__title-link';
      titleLink.textContent = item.title;
      if (item.url) titleLink.href = item.url;

      title.appendChild(titleLink);
      mobileItem.appendChild(title);

      const hero = document.createElement('div');
      hero.className = 'simple-table-mobile__hero';

      if (item.image) {
        const imageWrap = document.createElement('div');
        imageWrap.className = 'simple-table-mobile__image-wrap';

        const imageLink = document.createElement(item.url ? 'a' : 'div');
        if (item.url) imageLink.href = item.url;

        const img = document.createElement('img');
        img.className = 'simple-table-mobile__thumb';
        img.src = item.image;
        img.alt = item.title;

        imageLink.appendChild(img);
        imageWrap.appendChild(imageLink);
        hero.appendChild(imageWrap);
      }

      if (item.url && item.buttonText) {
        const button = document.createElement('a');
        button.className = 'btn btn--primary btn--small';
        button.href = item.url;

        const span = document.createElement('span');
        span.className = 'btn__text flex gap-1 items-center';
        span.textContent = item.buttonText;

        button.appendChild(span);
        hero.appendChild(button);
      }

      mobileItem.appendChild(hero);

      bodyRows.forEach((row) => {
        const labelCell = row.querySelector('th');
        const valueCells = row.querySelectorAll('td');
        const valueCell = valueCells[itemIndex];

        if (!labelCell || !valueCell) return;

        const rowEl = document.createElement('div');
        rowEl.className = 'simple-table-mobile__row';

        const labelEl = document.createElement('span');
        labelEl.className = 'simple-table-mobile__label';
        labelEl.textContent = labelCell.textContent.trim();

        const valueEl = document.createElement('div');
        valueEl.className = 'simple-table-mobile__value';
        valueEl.innerHTML = valueCell.innerHTML;

        rowEl.appendChild(labelEl);
        rowEl.appendChild(valueEl);
        mobileItem.appendChild(rowEl);
      });

      mobileWrap.appendChild(mobileItem);
    });

    table.insertAdjacentElement('afterend', mobileWrap);
  }
};

  const initFaq = () => {
    const faqs = document.querySelectorAll('.article-faq details');

    faqs.forEach((faq) => {
      const updateState = () => {
        faq.classList.toggle('is-open', faq.open);
      };

      updateState();
      faq.addEventListener('toggle', updateState);
    });

    const faqItems = document.querySelectorAll('.article-faq details');

    faqItems.forEach((item) => {
      const summary = item.querySelector('summary');
      const content = item.querySelector('div');

      if (!summary || !content) return;
      if (item.dataset.faqInitialized === 'true') return;
      item.dataset.faqInitialized = 'true';

      if (item.hasAttribute('open')) {
        item.classList.add('is-open');
        content.style.height = 'auto';
        content.style.opacity = '1';
      } else {
        content.style.height = '0px';
        content.style.opacity = '0';
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();

        const isOpen = item.hasAttribute('open');

        if (isOpen) {
          const contentHeight = content.scrollHeight;
          content.style.height = contentHeight + 'px';

          requestAnimationFrame(() => {
            item.classList.remove('is-open');
            content.style.height = '0px';
            content.style.opacity = '0';
          });

          const handleClose = function () {
            item.removeAttribute('open');
            content.removeEventListener('transitionend', handleClose);
          };

          content.addEventListener('transitionend', handleClose);
        } else {
          item.setAttribute('open', '');
          const contentHeight = content.scrollHeight;

          item.classList.add('is-open');
          content.style.height = '0px';
          content.style.opacity = '0';

          requestAnimationFrame(() => {
            content.style.height = contentHeight + 'px';
            content.style.opacity = '1';
          });

          const handleOpen = function () {
            content.style.height = 'auto';
            content.removeEventListener('transitionend', handleOpen);
          };

          content.addEventListener('transitionend', handleOpen);
        }
      });
    });
  };

  // ========== [カスタマイズ追記] ==========
  // 記事本文内の商品埋め込みカード（<div class="card" data-url="...">）の
  // 「カートに追加」ボタンを、決済ページに直行する Cart Permalink 形式の
  // 「購入する」リンクに差し替える
  //
  // URL形式: /cart/{バリアントID}:1?channel=buy_button
  // バリアントIDは /products/{handle}.js から取得（在庫ありの先頭バリアント優先）
  //
  // カード本体は別スクリプトが非同期でレンダリングするため、
  // MutationObserver で描画完了を監視して差し替える
  // 追記日: 2026-07-10
  // ======================================
  const initProductCardBuyLinks = () => {
    const CARD_SELECTOR = '.article__content .card[data-url], .rte .card[data-url]';
    const variantIdCache = new Map();

    const getVariantId = (handle) => {
      if (variantIdCache.has(handle)) return variantIdCache.get(handle);

      const promise = fetch(`/products/${handle}.js`)
        .then((res) => (res.ok ? res.json() : null))
        .then((product) => {
          if (!product || !product.variants || !product.variants.length) return null;
          const variant = product.variants.find((v) => v.available) || product.variants[0];
          return variant.id;
        })
        .catch((error) => {
          console.warn('Product card buy link: variant fetch failed:', handle, error);
          return null;
        });

      variantIdCache.set(handle, promise);
      return promise;
    };

    const findAddToCartEl = (card) => {
      const candidates = card.querySelectorAll('button, a');
      return (
        Array.from(candidates).find((el) => el.textContent.includes('カートに追加')) || null
      );
    };

    const processCard = async (card) => {
      if (card.dataset.buyLinkDone === 'true') return;

      const match = (card.dataset.url || '').match(/\/products\/([^/?#]+)/);
      if (!match) {
        card.dataset.buyLinkDone = 'true';
        return;
      }

      // カードのレンダリングがまだの場合は何もしない（Observerが再試行する）
      const addToCartEl = findAddToCartEl(card);
      if (!addToCartEl) return;

      card.dataset.buyLinkDone = 'true';

      const variantId = await getVariantId(match[1]);
      if (!variantId) return;

      const buyLink = document.createElement('a');
      buyLink.className = addToCartEl.className;
      buyLink.href = `/cart/${variantId}:1?channel=buy_button`;
      buyLink.innerHTML = addToCartEl.innerHTML.replace(/カートに追加/g, '購入する');

      addToCartEl.replaceWith(buyLink);
    };

    const processAllCards = () => {
      document.querySelectorAll(CARD_SELECTOR).forEach(processCard);
    };

    const observeTarget = document.querySelector('.article__content') || document.body;

    const observer = new MutationObserver(processAllCards);
    observer.observe(observeTarget, { childList: true, subtree: true });

    processAllCards();
  };

  const initArticlePage = async () => {
    moveArticleSections();
    // [カスタマイズ追記] 2026-07-10
    // 目次(INDEX)はデフォルトの記事テンプレートのみ生成する。
    // template.suffix は sections/main-article.liquid のインラインスクリプトが
    // window.__articleTplSuffix として出力（campaign等の代替テンプレでは値あり＝スキップ）。
    // 変数未定義（Liquid未反映）の場合は従来どおり生成にフォールバック。
    const isDefaultTemplate = !window.__articleTplSuffix;
    if (isDefaultTemplate) initArticleToc();
    initSupervisor();
    await initSimpleTables();
    initFaq();
    initProductCardBuyLinks();
  };

  initArticlePage();




  const readMoreBlocks = document.querySelectorAll('[data-read-more]');

  readMoreBlocks.forEach((block) => {
    const content = block.querySelector('.article-sns-embed__caption-inner');
    const toggle = block.querySelector('[data-read-more-toggle]');

    if (!content || !toggle) return;

    const collapsedHeight = parseFloat(
      getComputedStyle(content).getPropertyValue('--max-height')
    );

    if (content.scrollHeight <= collapsedHeight + 4) {
      toggle.style.display = 'none';
      block.classList.remove('is-collapsed');
      return;
    }

    toggle.addEventListener('click', () => {
      const isCollapsed = block.classList.contains('is-collapsed');

      block.classList.toggle('is-collapsed', !isCollapsed);
      toggle.setAttribute('aria-expanded', String(isCollapsed));
      toggle.textContent = isCollapsed ? '閉じる' : '続きを読む';
    });
  });



  
  const sliders = document.querySelectorAll('[data-sns-slider]');

  sliders.forEach((slider) => {
    const track = slider.querySelector('[data-sns-slider-track]');
    const slides = Array.from(slider.querySelectorAll('[data-sns-slide]'));
    const prevBtn = slider.querySelector('[data-sns-slider-prev]');
    const nextBtn = slider.querySelector('[data-sns-slider-next]');
    const dots = Array.from(slider.querySelectorAll('[data-sns-slider-dot]'));

    if (!track || slides.length === 0) return;

    const getCurrentIndex = () => {
      const slideWidth = track.clientWidth;
      if (!slideWidth) return 0;
      return Math.round(track.scrollLeft / slideWidth);
    };

    const updateDots = () => {
      const currentIndex = getCurrentIndex();
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === currentIndex);
      });
    };

    const scrollToIndex = (index) => {
      const clampedIndex = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({
        left: track.clientWidth * clampedIndex,
        behavior: 'smooth',
      });
    };

    prevBtn?.addEventListener('click', () => {
      scrollToIndex(getCurrentIndex() - 1);
    });

    nextBtn?.addEventListener('click', () => {
      scrollToIndex(getCurrentIndex() + 1);
    });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        scrollToIndex(index);
      });
    });

    track.addEventListener('scroll', () => {
      window.requestAnimationFrame(updateDots);
    });

    window.addEventListener('resize', updateDots);

    updateDots();
  });
});